import { useState } from 'react';
import { changePassword } from '../../../../entities/profile';
import { toast } from 'react-hot-toast';
import { LoaderCircle } from 'lucide-react';

export function ChangePasswordPage() {
  const [form, setForm] = useState({
    current_password: '',
    new_password: '',
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.current_password || !form.new_password) {
      toast.error('Please fill all fields');
      return;
    }

    setLoading(true);
    try {
      await changePassword(form);
      toast.success('Password changed successfully!');
      setForm({ current_password: '', new_password: '' });
    } catch (error) {
      console.error('Error changing password', error);
      toast.error(error?.response?.data?.message || 'Failed to change password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 w-full max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-6">Change Password</h2>

      <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-6">
        <form onSubmit={handleSubmit} className="space-y-6">
          <FormField label="Current Password" name="current_password" type="password" value={form.current_password} onChange={handleChange} required />

          <FormField label="New Password" name="new_password" type="password" value={form.new_password} onChange={handleChange} required />

          <div className="pt-4">
            <button type="submit" disabled={loading} className="flex items-center justify-center gap-2 px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition cursor-pointer disabled:opacity-50">
              {loading && <LoaderCircle className="w-4 h-4 animate-spin" />}
              Update Password
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

// 🔁 Reusable Input Field for Light Theme
function FormField({ label, name, value, onChange, type = 'text', required = false }) {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <input type={type} name={name} value={value} onChange={onChange} required={required} className="w-full px-3 py-2 rounded-lg border border-gray-300 bg-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" />
    </div>
  );
}
